export enum AuthRole {
  Admin = 'Admin',
  Senatran = 'Senatran',
  Company = 'Company',
  Citizen = 'Citizen',
}
